// Because we rely on observables, we are keeping deprecated input decorators
// until RxJs interop is stable.
/* eslint-disable @angular-eslint/prefer-signals */
import {
  Directive,
  Input,
  OnChanges,
  SimpleChanges,
  inject,
} from '@angular/core';

import { ValidSearchTypes } from '../../../private/utils/types.private';
import { UserDetailsService } from '../../services';

/** Helps reduce the number of API calls for entity details
 * by making a single call to the API each time the array of passed ids changes.
 * The directive itslef does not return any data.
 *
 * Example:
 ```html
 <some-component [pluginsPrefetchEntities]="someIds" searchType="user">
  <plugins-user-name *ngFor="let userId of someIds" [userId]="userId" />
</some-component>
* ```
*/
@Directive({
  selector: '[pluginsPrefetchEntities]',
  standalone: false,
})
export class PrefetchEntitiesDirective implements OnChanges {
  @Input() pluginsPrefetchEntities: string[] = [];
  @Input() searchType: ValidSearchTypes = 'all';
  private readonly userDetailsService = inject(UserDetailsService);

  ngOnChanges({ pluginsPrefetchEntities }: SimpleChanges): void {
    if (
      // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
      (pluginsPrefetchEntities || this.searchType) &&
      this.pluginsPrefetchEntities.length
    ) {
      void this.userDetailsService.findEntity(
        this.pluginsPrefetchEntities,
        this.searchType,
      );
    }
  }
}
